import posthog from "posthog-js";

const POSTHOG_CONFIG = {
  apiKey: import.meta.env.VITE_POSTHOG_API_KEY || "phc_test_key",
  options: {
    api_host: "https://us.i.posthog.com",
    person_profiles: "always" as const,
    capture_pageview: false, // We'll handle this manually
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
        tel: true,
        email: true,
      },
    },
  },
} as const;

export const posthogClient = posthog.init(
  POSTHOG_CONFIG.apiKey,
  POSTHOG_CONFIG.options,
);
